import {
  IGlobalPeriodContext,
  useGlobalPeriod,
  useStructureGrouping,
} from "../context";
import moment from "moment";
import { PortfolioProfitApi } from "@iliotech/generated-api-v3";
import { useQuery } from "react-query";
import { API_BASE } from "../../constants/constants";

export const useProfitHistory = (
  portfolioId: string,
  periodContext?: IGlobalPeriodContext
) => {
  const { period } = periodContext || useGlobalPeriod();
  const { grouping } = useStructureGrouping();
  const from = !!period?.from
    ? moment(period.from).format("YYYY-MM-DD")
    : undefined;
  const to = !!period?.to ? moment(period.to).format("YYYY-MM-DD") : undefined;
  const api = new PortfolioProfitApi(undefined, `${API_BASE}/api`);
  return useQuery(
    [`portfolio-profit-history`, { key: grouping.key, portfolioId, from, to }],
    () => api.getProfitHistory(portfolioId, grouping.key, from, to)
  );
};
